import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Header from '../../components/header/Header';
import Type1 from '../../questions/type1/Type1';
import Type2_4 from '../../questions/type2_4/Type2_4';
import Type5 from '../../questions/type5/Type5';
import Type6 from '../../questions/type6/Type6';
import Type7 from '../../questions/type7/Type7';
import Answer from '../../pop-ups/answer/Answer';
import TotalScore from '../../pop-ups/totalScore/TotalScore';
import ChangeDeviceWarning from '../../pop-ups/changeDeviceWarning/ChangeDeviceWarning';
import RotateDeviceWarning from '../../pop-ups/rotateDeviceWarning/RotateDeviceWarning';

import { QuestionType } from '../../utils/enums';
import { setDefaultState, setNextQuestion } from '../../store/sessionStatus';

import { HomeButtonSVG } from '../../assets/SVGAssets';
import CurrentScore from '../../pop-ups/currentScore/CurrentScore';
import Button from '../../components/button/Button';
import SoundSystem from '../../components/soundSystem/SoundSystem';
import './quizPage.css';

export default function QuizPage() {
    const dispatch = useDispatch();

    const componentState = useSelector((state) => state.session.component);

    const [component, setComponent] = useState(componentState);
    const question = useSelector((state) => state.questions);
    const currentSessionStatus = useSelector((state) => state.session);
    const questionNumber = currentSessionStatus.currentQuestionNumber;
    const questionsCount = question.length;

    const [homeButtonDisplay, setHomeButtonDisplay] = useState(true);

    const setAnswer = () => {
        setComponent('answer');

        dispatch(setNextQuestion());
    };

    const setTotalScore = () => {
        setComponent('totalScore');
    };

    const checkNextScreen = () => {
        questionNumber < questionsCount
            ? setComponent('question')
            : setComponent('totalScore');
    };

    useEffect(() => {
        if (
            component === 'currentScore' ||
            component === 'totalScore' ||
            !component
        ) {
            setHomeButtonDisplay(false);
        } else {
            setHomeButtonDisplay(true);
        }
    }, [component]);

    const setContent = () => {
        switch (component) {
            case 'question':
                switch (
                    question[questionNumber] &&
                    question[questionNumber].type
                ) {
                    case QuestionType.Link:
                        return (
                            <Type1
                                question={question[questionNumber]}
                                answer={() => setAnswer()}
                            />
                        );
                    case QuestionType.MultipleChoice:
                        return (
                            // eslint-disable-next-line
                            <Type2_4
                                question={question[questionNumber]}
                                answer={() => setAnswer()}
                            />
                        );
                    case QuestionType.DragAndDrop:
                        return (
                            <Type5
                                question={question[questionNumber]}
                                answer={() => setAnswer()}
                            />
                        );
                    case QuestionType.ClickMap:
                        return (
                            <Type6
                                question={question[questionNumber]}
                                answer={() => setAnswer()}
                            />
                        );
                    case QuestionType.LongMultipleChoice:
                        return (
                            <Type7
                                question={question[questionNumber]}
                                answer={() => setAnswer()}
                            />
                        );
                    case 'default':
                        return (
                            <Link
                                id="defaultQuizPage"
                                to={'/'}
                                onClick={() =>
                                    dispatch(setDefaultState())
                                }></Link>
                        );
                    default:
                        return;
                }
            case 'answer':
                return (
                    <Answer
                        status={currentSessionStatus.currentAnswerStatus}
                        description={question[questionNumber - 1].description}
                        descriptionImage={
                            question[questionNumber - 1].descriptionImage
                        }
                        descriptionConditions={
                            question[questionNumber - 1].descriptionConditions
                        }
                        next={checkNextScreen}
                    />
                );
            case 'totalScore':
                return (
                    <TotalScore
                        score={currentSessionStatus.totalScore}
                        questionCount={questionsCount}
                    />
                );

            case 'currentScore':
                return (
                    <CurrentScore
                        score={currentSessionStatus.totalScore}
                        questionCount={questionsCount}
                        setQuestionComponent={checkNextScreen}
                    />
                );
            default:
                return (
                    <Link id="default" to="/">
                        <Button type={'squareButton restart'} text="Restart" />
                    </Link>
                );
        }
    };

    return (
        <div id="quizWrapper">
            <Header />
            <div
                id="homeButton"
                style={{
                    display: `${homeButtonDisplay ? 'flex' : 'none'}`,
                }}>
                <Link to={'/menu'}>
                    <HomeButtonSVG showScore={setTotalScore} />
                </Link>
            </div>
            <SoundSystem
                audioFile={
                    component !== 'answer'
                        ? component === 'question' && question[questionNumber]
                            ? question[questionNumber].questionAudio
                            : ''
                        : question[questionNumber - 1].descriptionAudio
                }
            />
            <div id="quizContentWrapper">{setContent()}</div>
            <ChangeDeviceWarning />
            <RotateDeviceWarning />
        </div>
    );
}
